import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { lazyOperateContent } from 'owa-editor';

export async function addEditorUndoSnapshot(editorViewState: EditorViewState): Promise<void> {
    const operateContent = await lazyOperateContent.import();
    operateContent(editorViewState, (editor, range, domUtils) => {
        editor.addUndoSnapshot();
        return null;
    });
}
